export const getValidationRules = (servicesEnabled: boolean): any => ({
    companyUTR: servicesEnabled
        ? [
              { required: true, message: 'Company UTR is required' },
              {
                  pattern: /^\d{10,15}$/,
                  message: 'Company UTR must be 10 - 15 digits!',
              },
          ]
        : [],
    vatNumber: servicesEnabled
        ? [
              {
                  required: true,
                  message: 'Please input your VAT Number!',
              },
              {
                  pattern: /^\d{9}$/,
                  message: 'VAT Number must be exactly 9 digits and numeric!',
              },

              //   {
              //       pattern: /^\d+$/,
              //       message: 'VAT Number must be numeric!',
              //   },
          ]
        : [],
    addressLineOne: servicesEnabled
        ? [{ required: true, message: 'Please input your Address 1!' }]
        : [],
    town: servicesEnabled
        ? [{ required: true, message: 'Please input your Town' }]
        : [],
    country: servicesEnabled
        ? [{ required: true, message: 'Country is required' }]
        : [],
    postCode: servicesEnabled
        ? [{ required: true, message: 'Post Code is required' }]
        : [],
    endingDate: servicesEnabled
        ? [
              {
                  required: true,
                  message: 'Please input your First Peirod Ending Date',
              },
          ]
        : [],
    payeReference: servicesEnabled
        ? [
              {
                  required: true,
                  message: 'Please input your PAYE Reference!',
              },
              {
                  pattern: /^[0-9]{1,3}\/[A-Za-z0-9]{1,10}$/,
                  message: 'PAYE Reference must be in the format 123/A12345',
              },
          ]
        : [],
    accountOfficeReference: servicesEnabled
        ? [
              {
                  required: true,
                  message: 'Please input your Account Office Reference!',
              },
              {
                  pattern: /^[a-zA-Z0-9]+$/,
                  message:
                      'Account Office Reference must contain only letters and numbers!',
              },
              {
                  max: 15,
                  message:
                      'Account Office Reference cannot exceed 15 characters!',
              },
          ]
        : [],
    payrollFrequency: servicesEnabled
        ? [
              {
                  required: true,
                  message: 'Please select your Payroll Frequency!',
              },
          ]
        : [],
    schemeStartDate: servicesEnabled
        ? [
              {
                  required: true,
                  message: 'Please input Start Date!',
              },
          ]
        : [],
    stagingDate: servicesEnabled
        ? [
              {
                  required: true,
                  message: 'Please input Staging Date',
              },
          ]
        : [],
    fromDate: servicesEnabled
        ? [
              {
                  required: true,
                  message: 'Please input Start Date!',
              },
          ]
        : [],
})
